module.exports = {
	"config": {
		"siteTitle": "Gaël Destrem",
		"siteDescr": "Fullstack Developer",
		"siteAuthor": "Gaël Destrem",
		"siteLinkedinUrl": "https://www.linkedin.com/in/gaeldestrem/",
		"siteGithubUrl": "https://github.com/gaeldestrem",
		"siteEmailUrl": "gael.destrem@gmail.com",
		"googleAnalyticsId": "UA-46743284-1",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-01-04-new-year-resolution",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-01-04-new-year-resolution",
				"stem": "index",
				"path": "articles/2016-01-04-new-year-resolution/index.md"
			},
			"requirePath": "articles/2016-01-04-new-year-resolution/index.md",
			"path": "/hi-folks/",
			"data": {
				"title": "New year resolution !",
				"date": "2016-01-04",
				"layout": "post",
				"path": "/hi-folks/",
				"category": "random",
				"description": "So this is my new objective, start a blog and try to write a bit about new things (and the things that I learn too!). I'm going to write these article in English, it will be part of my personal english training :p  "
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-02-22-javascript-es6-favorite-features",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-02-22-javascript-es6-favorite-features",
				"stem": "index",
				"path": "articles/2016-02-22-javascript-es6-favorite-features/index.md"
			},
			"requirePath": "articles/2016-02-22-javascript-es6-favorite-features/index.md",
			"path": "/javascript-es6-favorite-features/",
			"data": {
				"title": "My 5 favorite features in Javascript ES6",
				"date": "2016-02-22",
				"layout": "post",
				"path": "/javascript-es6-favorite-features",
				"category": "javascript",
				"description": "I'm now using ES6 since a few months at my work, and I have to say, I'm not going back ! So, what's so awesome ? Here are my five favorite features !"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-03-02-deploy-private-composer-server-satis",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-03-02-deploy-private-composer-server-satis",
				"stem": "index",
				"path": "articles/2016-03-02-deploy-private-composer-server-satis/index.md"
			},
			"requirePath": "articles/2016-03-02-deploy-private-composer-server-satis/index.md",
			"path": "/deploy-private-composer-server-satis/",
			"data": {
				"title": "Private composer server with satis",
				"date": "2016-03-02",
				"layout": "post",
				"path": "/deploy-private-composer-server-satis",
				"category": "php/symfony",
				"description": "I use the Symfony stack at my work, and we have a code architecture with a lot of common components. (...) We came across a litle problem lately, everytime we're doing a composer update, it will take around five minutes"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-04-11-angular-1.5-hello-web-components",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-04-11-angular-1.5-hello-web-components",
				"stem": "index",
				"path": "articles/2016-04-11-angular-1.5-hello-web-components/index.md"
			},
			"requirePath": "articles/2016-04-11-angular-1.5-hello-web-components/index.md",
			"path": "/angular-1.5-hello-web-components",
			"data": {
				"title": "Angular 1.5 - Hello web components!",
				"date": "2016-04-11",
				"layout": "post",
				"path": "/angular-1.5-hello-web-components",
				"category": "angular",
				"description": "Angular 1.5 is now out, what are components ? Why you should use them ?"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-05-28-elasticsearch-autocomplete-suggestions",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-05-28-elasticsearch-autocomplete-suggestions",
				"stem": "index",
				"path": "articles/2016-05-28-elasticsearch-autocomplete-suggestions/index.md"
			},
			"requirePath": "articles/2016-05-28-elasticsearch-autocomplete-suggestions/index.md",
			"path": "/elasticsearch-autocomplete-suggestions/",
			"data": {
				"title": "Elasticsearch - Autocomplete suggestions",
				"date": "2016-05-28",
				"layout": "post",
				"path": "/elasticsearch-autocomplete-suggestions",
				"category": "elasticsearch",
				"description": "Ideally, auto-complete functionnality should be as fast as the user typing to provide instant feedback. If you're doing your autocomplete implementation by using regex-like searches in your DB (ie: gith*), you're doing it wrong"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-06-14-docker-1-12-lets-swarm",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-06-14-docker-1-12-lets-swarm",
				"stem": "index",
				"path": "articles/2016-06-14-docker-1-12-lets-swarm/index.md"
			},
			"requirePath": "articles/2016-06-14-docker-1-12-lets-swarm/index.md",
			"path": "/docker-1-12-lets-swarm/",
			"data": {
				"title": "Docker 1.12 - Let's swarm!",
				"date": "2016-06-14",
				"layout": "post",
				"path": "/docker-1-12-lets-swarm",
				"category": "docker",
				"description": "Docker 1.12 is probably the most important release since 1.0. Docker 1.12 has added features to make multi-host and multi-container orchestration available for everyone who wants or needs it."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-09-08-php7-whats-up",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-09-08-php7-whats-up",
				"stem": "index",
				"path": "articles/2016-09-08-php7-whats-up/index.md"
			},
			"requirePath": "articles/2016-09-08-php7-whats-up/index.md",
			"path": "/php7/",
			"data": {
				"title": "PHP 7 - Scalar type and new operators",
				"date": "2016-09-08",
				"layout": "post",
				"path": "/php7",
				"category": "php/symfony",
				"description": "PHP7 is not only about performance improvements. There are a also a few cool new things that came out !"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-03-elasticsearch5-whats-new",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-03-elasticsearch5-whats-new",
				"stem": "index",
				"path": "articles/2016-11-03-elasticsearch5-whats-new/index.md"
			},
			"requirePath": "articles/2016-11-03-elasticsearch5-whats-new/index.md",
			"path": "/elasticsearch-5/",
			"data": {
				"title": "Elasticsearch 5 - New features",
				"date": "2016-11-03",
				"layout": "post",
				"path": "/elasticsearch-5",
				"category": "elasticsearch",
				"description": "Say heya to the new Elastic Stack (ELK). I'm going to focus on Elasticsearch 5 new features and changes as it the product from the stack I use the most"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-01-17-vue-js-webpack",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-01-17-vue-js-webpack",
				"stem": "index",
				"path": "articles/2017-01-17-vue-js-webpack/index.md"
			},
			"requirePath": "articles/2017-01-17-vue-js-webpack/index.md",
			"path": "/vuejs/",
			"data": {
				"title": "Vue.js - The simplicity !",
				"date": "2017-01-17",
				"layout": "post",
				"path": "/vuejs",
				"category": "javascript",
				"description": "This is like React but easier and faster to build stuff with. I’m using Vue.js since september and I’m still impressed by how everything feels natural and simple."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md"
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact me",
				"layout": "page",
				"path": "/contact"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/freelance",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/freelance",
				"stem": "index",
				"path": "pages/freelance/index.md"
			},
			"requirePath": "pages/freelance/index.md",
			"path": "/freelance/",
			"data": {
				"title": "Freelance",
				"layout": "page",
				"path": "/freelance"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0